
import { CarHealth } from '@clients/bff'
import { Location, Trip, TripLog } from '@clients/myTrips'
import FuelIcon from '@components/icons/icon-fuel-tank.svg'
import SpeedIcon from '@components/icons/summary/icon-tachometer.svg'
import PositionMap from '@components/my-trips/PositionMap.vue'
import AppContent from '@components/new-styleguide/AppContent.vue'
import AppHeader from '@components/new-styleguide/AppHeader.vue'
import AppPage from '@components/new-styleguide/AppPage.vue'
import TripStatisticBarItem from '@components/new-styleguide/TripStatisticBarItem.vue'
import DeviceHelpSection from '@components/shared/section/DeviceHelpSection.vue'
import NoTripsSection from '@components/shared/section/NoTripsSection.vue'
import RestartSetupSection from '@components/shared/section/RestartSetupSection.vue'
import showHeaderFooter from '@util/headerFooterUtils'
import { formatLocale } from '@util/numberFormat'
import { formatTripOdometer } from '@util/odometerService'
import storageService from '@util/storageService'
import { LoadState } from '@util/types'
import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const TriplogModule = namespace('Triplog');
const CarHealthModule = namespace('CarHealth');

@Component({
  name: 'TeaserWidget',
  components: {
    RestartSetupSection,
    DeviceHelpSection,
    NoTripsSection,
    AppHeader,
    AppContent,
    AppPage,
    PositionMap,
    TripStatisticBarItem,
    SpeedIcon,
    FuelIcon
  }
})
export default class TeaserWidget extends Vue {

  @TriplogModule.Getter('getVehicles')
  private triplogs: TripLog[];

  @TriplogModule.Getter('getVehiclesStatus')
  private vehiclesStatus: LoadState;

  @TriplogModule.Getter('getLatestTripLocation')
  private vehiclePosition: Location;

  @TriplogModule.Getter('getLatestTrip')
  private latestTrip: Trip;

  @TriplogModule.Getter('getLatestTripStatus')
  private latestTripStatus: LoadState;

  @TriplogModule.Action('fetchLatestTrip')
  private fetchLatestTrip;

  @CarHealthModule.Action('fetchCarHealth')
  private fetchCarHealth;

  @CarHealthModule.Getter('getCarHealth')
  private carHealth: CarHealth;

  @CarHealthModule.Getter('getCarHealthStatus')
  private carHealthStatus: LoadState;

  mounted() {
    this.fetchData();

    const headerList = document.getElementsByTagName('header');
    const footerList = document.getElementsByTagName('footer');

    for (let i = 0; i < headerList.length; i++) {
      headerList.item(i).classList.add("hide-element");
    }

    for (let i = 0; i < footerList.length; i++) {
      footerList.item(i).classList.add("hide-element");
    }
  }

  @Watch('vehicleId')
  fetchData() {
    if (this.vehicleId) {
      this.fetchLatestTrip({ vehicleId: this.vehicleId });
      this.fetchCarHealth({ vehicleId: this.vehicleId });
    }
  }

  addHeaderFooter() {
    showHeaderFooter();
  }

  get isLoading() {
    return this.carHealthStatus === LoadState.Loading || this.vehiclesStatus === LoadState.Loading || this.latestTripStatus === LoadState.Loading;
  }

  get vehicleId() {
    const vehicleIdFromPath = this.$route.params.id;
    const vehicleIdFromStorage = storageService.getVehicleId() && storageService.getVehicleId() != "-1" ? storageService.getVehicleId() : undefined;
    const firstVehicleIdFromTriplogs = this.triplogs[0]?.vehicle?.id?.toString();

    return vehicleIdFromPath || vehicleIdFromStorage || firstVehicleIdFromTriplogs;
  }

  get formattedFuelLevel() {
    return this.carHealth.lastFuelLevel ? formatLocale(this.carHealth.lastFuelLevel, 0).toString() : '---';
  }

  get formattedOdometer() {
    return this.carHealth.odometer ? formatTripOdometer(this.carHealth.odometer).toString() : '---';
  }

  get aggregateFill() {
    if (!this.carHealth) {
      return 'url(#oeamtc-gradient__neutral)'
    }
    switch(this.carHealth.aggregateState) {
      case "UNPLUGGED": return 'url(#oeamtc-gradient__neutral)'
      case "RED": return 'url(#oeamtc-gradient__danger)'
      case "YELLOW": return 'url(#oeamtc-gradient__warning)'
      case "GREEN": return 'url(#oeamtc-gradient__success)'
    }
  }

  get numIssues() {
    return this.carHealth?.numIssues?.toString() ?? '0';
  }

  get smartConnected() {
    return this.triplog?.smartConnected;
  }

  get hasNoTrips() {
    return !this.latestTrip;
  }

  get triplog() {
    return this.triplogs && this.triplogs.find((triplog) => triplog.vehicle.id.toString() === this.vehicleId);
  }

  get showRestartSetup() {
    return this.triplog && !!this.triplog.vehicle.deviceId && this.triplog.vehicle.setupDone === false;
  }

}

